export const EXTERNAL_DATA_SEARCH_PARAM = "external_data";
